// ** React Imports
import { Fragment, useEffect, useState } from 'react'

// ** Third Party Components
import classnames from 'classnames'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Bell, BellOff } from 'react-feather'

// ** Reactstrap Imports
import { Button, Badge, DropdownMenu, DropdownItem, DropdownToggle, UncontrolledDropdown, Input, Form, FormGroup, Label } from 'reactstrap'
import { useHistory } from 'react-router-dom'
import { GET_NOTIFICATION_WITHOUT_PAGINATION, GET_SUBSCRIPTION, UPDATE_NOTIFICATION } from '../../../../ui/pages/AssociateVendors/query'
import { useMutation, useQuery, useSubscription } from 'react-apollo'
import { toast } from 'react-toastify'

const NotificationDropdown = () => {
	const history = useHistory();
	const [open, setOpen] = useState();
	const { data: notifications } = useSubscription(GET_SUBSCRIPTION)
	const [notification, setNotification] = useState();
	const [count, setcount] = useState();
	const [status, setStatus] = useState('');
	const [showUnReadOnly, setShowUnReadOnly] = useState(false)
	const [updateNotification] = useMutation(UPDATE_NOTIFICATION)
	const { data, refetch } = useQuery(GET_NOTIFICATION_WITHOUT_PAGINATION, {
		variables: {},
		// variables: { getAllNotificationsWithoutPaginationId: JSON.parse(userRes)?.id },
		fetchPolicy: "cache-and-network",
	})

	useEffect(() => {
		if (data?.getAllNotificationsWithoutPagination) {
			const status = data?.getAllNotificationsWithoutPagination?.filter((d) => d?.status === "unRead")
			setNotification(data?.getAllNotificationsWithoutPagination)
			setcount(status?.length)
		}

	}, [data])

	useEffect(() => {
		notifications?.createNotification && refetch && refetch();
		notification?.length > 0 && notification?.[notification?.length - 1]?.message &&
			toast?.info(notification?.[notification?.length - 1]?.message, {
				icon: <Bell />
			});
	}, [notifications])

	const submitHandler = (e) => {
		setOpen(false);
		history.push("/notification");
	};

	const UpdateHandler = (category, id) => {
		updateNotification({
			variables: { updateNotificationId: id }
		}).then((res) => {
			if (res?.data?.updateNotification) {
				switch (category) {
					case "Hold Request":
						history.push(`/hold-requests`);
						break;
					case "Enquiry Request":
						history.push(`/enquiries`);
						break;
					case "Invoice Request":
						history.push(`/invoice`);
						break;
					case "MakeToOrder Request":
						history.push(`/makeToOrder`);
						break;

					default:
						// Handle default case if needed
						break;
				}

				setOpen(false)
				refetch && refetch()
			}
			else {
				toast.error("Not update status")
				setOpen(false)
			}


		}).catch((error) => {
			toast.error(error)


		})
	}
	const onClickHandler = (e) => {
		e.preventDefault()
		setOpen(true)
	}


	// ** Function to render Notifications
	/*eslint-disable */
	const renderNotificationItems = () => {
		const filterNotification = showUnReadOnly ? notification.filter(item => item?.status !== 'read') : notification
		return (
			<PerfectScrollbar
				component='li'
				className='media-list scrollable-container'
				options={{
					wheelPropagation: false
				}}
			>
				{filterNotification && filterNotification.map((item, index) => {
					// {notification && notification.map((item, index) => {
					return (
						<a key={index} className='d-flex' href='/' onClick={e => e.preventDefault()}>
							<div className={classnames('list-item d-flex', { 'align-items-start': !item.switch, 'align-items-center': item.switch })} onClick={() => UpdateHandler(item?.category, item?.id)}>
								{!item.switch ? (
									<Fragment>
										<div className='me-1'> {item?.status === 'read' ? <Bell /> : <BellOff />}</div>
										<div className="list-item-body flex-grow-1">
											<p className="media-heading"><span className={item?.status !== 'read' ? 'fw-bolder' : 'fw-light'} >{item?.category}</span>&nbsp;</p>
											<small className={item?.status !== 'read' ? 'fw-bolder' : 'notification-text'}> {item?.message} </small>
										</div>
										{item?.status !== "read" && <Badge color="danger" pill>unread</Badge>}
									</Fragment>
								) : (
									<Fragment>
										{item.title}
										{item.switch}
									</Fragment>
								)}
							</div>
						</a>
					)
				})}
			</PerfectScrollbar>
		)
	}
	/*eslint-enable */

	return (

		<UncontrolledDropdown
			tag="li"
			className="dropdown-notification nav-item me-25"
		>
			<DropdownToggle
				tag="a"
				className="nav-link"
				href="/"
				onClick={(e) => onClickHandler(e)}
			>
				<Bell size={21} />
				{count > 0 && (
					<Badge pill color="danger" className="badge-up">
						{count}
					</Badge>
				)}
			</DropdownToggle>
			{open && (
				<DropdownMenu end tag="ul" className="dropdown-menu-media mt-0">
					<li className="dropdown-menu-header position-relative">
						
						<DropdownItem className="d-flex" tag="div" header>
							<h4 className="notification-title mb-0 me-auto">Notifications</h4>
							<Badge tag="div" color="light-primary" pill>
								{count} New
							</Badge>
						</DropdownItem>
					
						<div className="form-check form-switch ms-auto position-absolute top-0 end-0" style={{marginRight: "100px" ,marginTop: "15px"}}>
								<Input
									className="custom-control-success"
									type="switch"
									style={{ zIndex: 0 }}
									defaultChecked={showUnReadOnly}
									onClick={() => {
										setShowUnReadOnly(!showUnReadOnly);
									}}
								/>
						</div>
					</li>

					{renderNotificationItems()}
					<li className="dropdown-menu-footer">
						{notification?.length > 0 && <Button color="primary" block onClick={(e) => submitHandler(e)}>
							Read all notifications
						</Button>}
					</li>
				</DropdownMenu>
			)}
		</UncontrolledDropdown>
	)
}

export default NotificationDropdown
